module.exports = __webpack_public_path__ + "static/media/PeopleNoConsumables_Mobile_2x.96cf945d.jpg";